var _path, _rect, _path2, _path3, _ellipse, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 2.08317L11.6668 3.99986C11.6668 4.93328 11.6668 5.39999 11.8485 5.75651C12.0083 6.07012 12.2632 6.32509 12.5768 6.48487C12.9334 6.66653 13.4001 6.66653 14.3335 6.66653L16.2502 6.66653M16.6668 8.5946L16.6668 11.6665C16.6668 14.0001 16.6668 15.1668 16.2127 16.0581C15.8132 16.8421 15.1758 17.4796 14.3918 17.879C13.5005 18.3332 12.3337 18.3332 10.0002 18.3332C7.66661 18.3332 6.49983 18.3332 5.60853 17.879C4.82452 17.4796 4.18711 16.8421 3.78763 16.0581C3.33349 15.1668 3.33349 14.0001 3.33349 11.6665L3.33349 8.14832C3.3335 5.98898 3.3335 4.90931 3.72399 4.07203C4.13796 3.1844 4.85139 2.47097 5.73902 2.057C6.5763 1.6665 7.65597 1.6665 9.81531 1.66651C10.7589 1.66651 11.2307 1.66651 11.6762 1.7653C12.1507 1.8705 12.603 2.05788 13.0129 2.31897C13.3978 2.56418 13.7314 2.89778 14.3986 3.56498L14.7142 3.88055C15.4348 4.60118 15.7952 4.9615 16.0528 5.38199C16.2813 5.75479 16.4496 6.16122 16.5517 6.58637C16.6668 7.06591 16.6668 7.57547 16.6668 8.5946Z",
    stroke: "#6E707A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 8.3335,
    width: 16.6667,
    height: 7.5,
    rx: 2,
    fill: "#F6EED2",
    stroke: "#D3AC1E",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 10.4165L4.1665 13.7498",
    stroke: "#D3AC1E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 10.4165L4.99984 10.4165C5.92031 10.4165 6.6665 11.1627 6.6665 12.0832V12.0832C6.6665 13.0036 5.92031 13.7498 4.99984 13.7498L4.1665 13.7498",
    stroke: "#D3AC1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 12.0832,
    rx: 1.25,
    ry: 1.66667,
    stroke: "#D3AC1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 10.4165L15.0002 10.4165C14.0797 10.4165 13.3335 11.1627 13.3335 12.0832V12.0832C13.3335 13.0036 14.0797 13.7498 15.0002 13.7498L15.8335 13.7498",
    stroke: "#D3AC1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocIcon);
export default ForwardRef;